import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function convertCamelCaseToTitleCase(camelCaseString: string): string {
  if (!camelCaseString) return '';

  const COMMON_ABBREVIATIONS = ['ID', 'DOB'];
  let result = camelCaseString.replace(/([a-z0-9])([A-Z])/g, '$1 $2');

  result = result
    .split(' ')
    .map(word => {
      const upper = word.toUpperCase();
      if (COMMON_ABBREVIATIONS.includes(upper)) {
        return upper;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ')
    .trim();

  return result;
}
